import { render, staticRenderFns } from "./EmployeeDashboard.vue?vue&type=template&id=2c413b32&scoped=true&"
import script from "./EmployeeDashboard.vue?vue&type=script&lang=js&"
export * from "./EmployeeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDashboard.vue?vue&type=style&index=0&id=2c413b32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c413b32",
  null
  
)

export default component.exports